module.exports = __webpack_public_path__ + "img/img_1.f9b0da3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/img_1.png
// module id = zZe3
// module chunks = 1